import normalizeThreadTimestamp from '@/lib/threads/normalizeThreadTimestamp.js';

const toThreadTimestampMs = (value) => {
  const normalized = normalizeThreadTimestamp(value);

  if (!normalized) {
    return null;
  }

  const parsed = Date.parse(normalized);

  if (!Number.isFinite(parsed)) {
    return null;
  }

  return parsed;
};

export default toThreadTimestampMs;
